import i18next from 'i18next'
import { budgetApiClient, transactionApiClient } from './apis'

export async function getSmartCheckSessionOutputPdf(): Promise<string> {
	try {
		const response = await budgetApiClient
			.timeout(false)
			.retry(5)
			.get(`smart-check-sessions/pdf?langauge=${i18next.language}`)

		const byteString = window.atob(response)
		const arrayBuffer = new ArrayBuffer(byteString.length)
		const int8Array = new Uint8Array(arrayBuffer)
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i)
		}
		const blob = new Blob([int8Array], { type: 'application/pdf' })

		return window.URL.createObjectURL(blob)
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			data: error.response?.data,
		})
	}
}

export async function logSmartCheckSessionError(
	instructionId: string,
	errorMessage: string,
	errorType: string,
): Promise<[number, string]> {
	try {
		const response = await transactionApiClient.post<any>(
			`consumer-data-pull-sessions/log-error`,
			{
				instructionId: instructionId,
				errorMessage: errorMessage,
				errorType: errorType,
				registeredOn: new Date(),
			},
		)
		return [response.status, response.data]
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}
